export default __webpack_public_path__ + "static/media/google.84030875.svg";